<template>
  <div v-if="opqIf">
    <div v-for="(item, index) in list" :key="item.id">
      <v-card
        class="mb-3 pa-4 pt-12 pt-sm-4"
        :max-width="cardWidth"
        outlined
        :class="{ isError: !withoutValidation && !valids[index] && !item.isExpanded }"
      >
        <div v-show="item.isExpanded">
          <!-- Mode d'édition (reçoit l'item en props) -->
          <div class="mt-6">
            <slot v-if="withoutValidation" name="edit-mode" :item="item"></slot>
            <v-form v-else :ref="`iteratorForm_${index}`" v-model="valids[index]">
              <slot name="edit-mode" :item="item"></slot>
            </v-form>
          </div>

          <div style="position: absolute; top: 10px; right: 10px">
            <v-btn v-show="!hideDelete && !item.undeletable" icon color="error" @click="deleteItem(item, index)" class="mr-2">
              <v-icon medium>mdi-delete</v-icon></v-btn
            >
            <v-btn icon color="primary" @click="item.isExpanded = !item.isExpanded">
              <v-icon medium>mdi-content-save</v-icon></v-btn
            >
          </div>
        </div>
        <div v-show="!item.isExpanded">
          <v-alert
            text
            type="error"
            v-if="!withoutValidation && !valids[index]"
            class="error--text"
            style="max-width: 70%"
            >Une réponse obligatoire est manquante</v-alert
          >
          <!-- Mode d'affichage (reçoit l'item en props) -->
          <div
            :class="{ 'd-flex': icon, 'font-italic': item.inactif, 'grey--text': item.inactif }"
            style="max-width: 95%"
          >
            <v-icon v-if="icon" class="mr-6" x-large :color="item.inactif ? 'light-grey' : 'primary'">{{
              icon
            }}</v-icon>
            <div>
              <slot name="show-mode" :item="item"></slot>
              <slot name="points"
                ><p class="my-0 font-weight-bold" v-show="!item.lectureSeule && !hideDots">...</p></slot
              >
              <slot name="show-mode-after-dots" :item="item"></slot>
            </div>
          </div>

          <v-btn
            v-show="!item.lectureSeule && !item.inactif"
            style="position: absolute; top: 10px; right: 10px"
            icon
            color="primary"
            @click="item.isExpanded = !item.isExpanded"
            ><v-icon medium>mdi-pencil</v-icon></v-btn
          >
        </div>
      </v-card>
    </div>

    <v-btn v-if="!hideAdd" text color="primary" @click="addItem"
      ><v-icon class="mr-2">mdi-plus</v-icon>{{ addNewText }}</v-btn
    >
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="list.length > 0"
      :rules="[(v) => optional || !!v || noElementMessage]"
    ></v-checkbox>
  </div>
</template>

<script>
import { Api, Queue } from "@/plugins/api"

// @group Champs
export default {
  props: {
    // Le texte sur le bouton Ajouter
    addNewText: {
      type: String,
      default: "Ajouter un élément",
    },

    noElementMessage: {
      type: String,
      default: "Veuillez saisir au moins un élément",
    },

    // La liste à afficher
    list: {
      type: Array,
      required: true,
    },

    // Objet pour être en live sur Eudonet ({endpoint, sasId}). Le Endpoint devrait implémenter SasMultipleBaseController
    live: {
      type: Object,
    },

    optional: {
      type: Boolean,
      default: false,
    },
    cardWidth: {
      type: String,
      default: "600",
    },
    icon: {
      type: String,
      default: "",
    },
    valids: {
      type: Array,
      default: () => {
        return []
      },
    },
    opqIf: {
      type: Boolean,
      default: true,
    },
    withoutValidation: { type: Boolean, default: false },
    hideDots: { type: Boolean, default: false },
    hideAdd: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false },
  },
  watch: {
    opqIf(newValue) {
      if (!newValue) {
        for (let index = 0; index < this.list.length; index++) {
          this.deleteItem(this.list[index], index)
        }
      }
    },
  },
  methods: {
    addItem() {
      let newItem = null
      if (this.live) {
        Queue.enqueue(() =>
          Api.post(this.live.endpoint + "/new/" + this.live.sasId, this.live.payload)
            .then((res) => {
              newItem = res.data
              newItem.isExpanded = true
              this.list.push(newItem)
            })
            .finally(() => {
              // Lorsqu'un item est ajouté
              // @arg Le nouvel item ajouté à la liste
              this.$emit("addItem", newItem)
            }),
        )
      } else {
        this.$emit("addItem", newItem)
      }
    },

    deleteItem(item, index) {
      if (this.live) {
        Api.post(this.live.endpoint + "/delete/" + item.id).then(() => {
          this.list.splice(this.list.indexOf(item), 1)
          this.valids.splice(index, 1)
          // Lorsqu'un item est supprimé
          // @arg L'item supprimé de la liste
          this.$emit("deleteItem", item)
        })
      } else {
        this.list.splice(this.list.indexOf(item), 1)
        this.valids.splice(index, 1)
        this.$emit("deleteItem", item)
      }
    },
  },
}
</script>

<style>
.list_counter_validator > .v-input__control > .v-input__slot {
  display: none !important;
}
.list_counter_validator > .v-input__control > .v-messages {
  font-size: inherit;
}
.theme--light.v-card.isError {
  border-color: var(--v-error-base);
  border-width: 2px;
}
</style>
